const EARTH_RADIUS_KM = 6371

const toRadians = (degrees: number) => (degrees * Math.PI) / 180

interface ICoordinates {
    lat: number
    lng: number
}

/** Great-circle distance in kilometers (as the crow flies) */
export const haversineDistanceKm = (from: ICoordinates, to: ICoordinates): number => {
    const dLat = toRadians(to.lat - from.lat)
    const dLng = toRadians(to.lng - from.lng)

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRadians(from.lat)) * Math.cos(toRadians(to.lat)) * Math.sin(dLng / 2) ** 2

    return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a))
}

/** "650 m" below one kilometer, "1,2 km" (locale decimal) below ten, "12 km" above */
export const formatDistanceKm = (distanceKm: number, locale: string): string => {
    if (distanceKm < 1) {
        return `${Math.max(50, Math.round((distanceKm * 1000) / 50) * 50)} m`
    }

    if (distanceKm < 10) {
        return `${distanceKm.toLocaleString(locale, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        })} km`
    }

    return `${Math.round(distanceKm)} km`
}
